// extracted by mini-css-extract-plugin
export default {"container":"PopUpCard_container__2Tmz8","header":"PopUpCard_header__zQz7M","closeIcon":"PopUpCard_closeIcon__s0AXW","card":"PopUpCard_card__aLnnF"};